export default [
  {
    path: '/yoOrderList/:status?',
    name: 'yoOrderList',
    meta: {
      keepAlive: true
    },
    component: () =>
      import(
        /* webpackChunkName: "yourOrder" */ '@/views/yourOrder/orderList/YOOrderList.vue'
      )
  },
  {
    path: '/yoOrderDetail/:id/:status?',
    name: 'yoOrderDetail',
    component: () =>
      import(
        /* webpackChunkName: "detailOrder" */ '@/views/yourOrder/orderDetail/YOOrderDetail.vue'
      )
  },
  {
    path: '/shipmentInfo/:id/:active?',
    name: 'shipmentInfo',
    component: () =>
      import(
        /* webpackChunkName: "shipmentInfo" */ '@/views/yourOrder/shipment/ShipmentInfo.vue'
      )
  },
  {
    path: '/yoSelectCancelItems/:id?',
    name: 'yoSelectCancelItems',
    component: () =>
      import(
        /* webpackChunkName: "yoSelectCancelItems" */ '@/views/yourOrder/cancelOrder/YOSelectCancelItems.vue'
      )
  },
  {
    path: '/yoSelectCancelReasons/:id?',
    name: 'yoSelectCancelReasons',
    component: () =>
      import(
        /* webpackChunkName: "yoSelectCancelReasons" */ '@/views/yourOrder/cancelOrder/YOSelectCancelReasons.vue'
      )
  },
  {
    path: '/cReturnSelectItems/:id',
    name: 'cReturnSelectItems',
    component: () =>
      import(
        /* webpackChunkName: "cReturnSelectItems" */ '@/views/yourOrder/orderReturn/CReturnSelectItems.vue'
      )
  },
  {
    path: '/cReturnSelectReason/:id',
    name: 'cReturnSelectReason',
    component: () =>
      import(
        /* webpackChunkName: "cReturnSelectReason" */ '@/views/yourOrder/orderReturn/CReturnSelectReason.vue'
      )
  },
  {
    path: '/cReturnSubmitApplication',
    name: 'cReturnSubmitApplication',
    component: () =>
      import(
        /* webpackChunkName: "returnApply" */ '@/views/yourOrder/orderReturn/CReturnSubmitApplication.vue'
      )
  },
  {
    path: '/cReturnApplicationResult/:id',
    name: 'cReturnApplicationResult',
    component: () =>
      import(
        /* webpackChunkName: "returnResults" */ '@/views/yourOrder/orderReturn/CReturnApplicationResult.vue'
      )
  },
  {
    path: '/asList',
    name: 'asList',
    component: () =>
      import(
        /* webpackChunkName: "asList" */ '@/views/yourOrder/afterSale/ASList.vue'
      )
  },
  {
    path: '/asDetail/:orderId/:contractId',
    name: 'asDetail',
    component: () =>
      import(
        /* webpackChunkName: "asDetail" */ '@/views/yourOrder/afterSale/ASDetail.vue'
      )
  },
  {
    path: '/yoCustomerReview/:reviewStatus?',
    name: 'yoCustomerReview',
    component: () =>
      import(
        /* webpackChunkName: "yoCustomerReview" */ '@/views/yourOrder/customerReview/CustomerReview.vue'
      )
  },
  {
    path: '/createReview/:orderId?/:asin?',
    name: 'createReview',
    component: () =>
      import(
        /* webpackChunkName: "createReview" */ '@/views/yourOrder/customerReview/CreateReview.vue'
      )
  }
];
